import axios from 'axios';
import { configAxios } from '../axiosUtils';

const ENDPOINT = '';

configAxios();

export const Auth = {
  login({ email, password }: { email: string; password: string }) {
    return axios.post(`${ENDPOINT}/login`, {
      email,
      password,
    });
  },
};
